<template>
  <t-form :requiredMark="true" :labelAlign="option.attribute.labelAlign">
    <t-form-item
      :label="option.attribute.label"
      :style="setStyles"
      class="my_password"
    >
      <t-input
        class="my_password_item"
        v-model="iptVal"
        :style="setStyles"
        :placeholder="option.attribute.placeholder"
        :align="option.attribute.align"
         @blur="checkValue"
         @change="checkValue"
        :status="message"
        :tips="tips"
      />
    </t-form-item>
    <!-- <t-form-item
      :label="option.attribute.dblabel"
      :style="setStyles"
      class="my_input_form"
    >
      <t-input
        class="my-input"
        v-model="iptVal1"
        :style="setStyles"
        :placeholder="`${option.attribute.placeholder}${option.attribute.dblabel}`"
        :align="option.attribute.align"
        @blur="checkValue"
        @change="checkValue"
        :status="message1"
        :tips="tips1"
      
      />
    </t-form-item> -->
  </t-form>
<!-- <t-button @click="test()">确定</t-button> -->
</template>

<script>
export default {
  name: "cpt-password",
  props: {
    option: Object, 
    current: Object, 
    components: Array,
    height:Number,
    refMap: Object,
  },
  computed: {
    setStyles() {
      return {
         "--width": this.current.cptWidth + "px",
        "--height": this.option.attribute.height + "px",
        "--indent": this.option.attribute.indent + "px",
        "--bgColor": this.option.attribute.bgColor,
        "--textColor": this.option.attribute.textColor,
        "--placholderColor": this.option.attribute.textPlaceholderColor,
        "--fontStyle": this.option.attribute.fontStyle,
        "--fontWeight": this.option.attribute.fontWeight,
        "--fontFamily": this.option.attribute.fontFamily,
        "--fontSize": this.option.attribute.fontSize + "px",
        "--borderSize": this.option.attribute.borderSize + "px",
        "--borderColor": this.option.attribute.borderColor,
        "--borderRadius": this.option.attribute.borderRadius + "px",
        "--lineType": this.option.attribute.lineType,
      };
    },
    regex() {
      switch (this.option.attribute.psLevel) {
        case 'small':
          return /^[\S]{$this.min,$this.max}$/;
        case 'medium':
          return /^(?=.*[A-z])(?=.*\\d)[\\da-zA-Z\\d]{$this.min,$this.max}$/ +
            /^(?=.*\\d)(?=.*[A-z])[\\da-zA-Z\\d]{$this.min,$this.max}$/+
            /^(?=.*[A-z])(?=.*\\d)[\\da-zA-Z\\d]{$this.min,$this.max}$/
        case 'large':
          return /^(?=.*[A-Z])(?=.*[a-z])(?=.*\d)(?=.*[~!@#$%^&*_.]).{$this.min,$this.max}$/;
        default:
          throw new Error('Invalid psLevel');
      }
    },
  },
  data() {
    return {
      iptVal: "",
      message: "default",
      tips: "",
      min: 6,
      max: 20,
    };
  },
  created() {},
  methods: {
    // 校验方法
    checkValue() {
      // console.log(this.current,'this.current')
      if (Array.isArray(this.current.group) && this.current.group.length > 0) {
        // console.log(this.refMap[this.current.group[0]],'*')
        // console.log(this.refMap[this.current.group[1]],'*')
        // console.log(this.refMap[this.current.group[0]].option.attribute.label,'*')
        // console.log(this.refMap[this.current.group[1]].option.attribute.label,'*')
        // let password = this.refMap[this.current.group[1]];
        // let setPassword = this.refMap[this.current.group[0]]
        //    if(password.iptVal  == '') {
        //       this.setValidationMessage(false,`${password.option.attribute.label}必填`);
        //        return false
        //     } 

        //     if(setPassword.iptVal  == '') {
        //       this.setValidationMessage(false,`${222222}必填`);
        //        return false
        //     } 

          // if(Array.isArray(this.components) && this.components.length > 0) {
          //   //  this.components.forEach(item => {
          //   //   console.log(item,'item')
          //   //     if (this.current.group.includes(item.id) && item.cptKey == 'cpt-password') {
          //   //         // console.log(item,'item')
          //   //         console.log(this.refMap[item.id].iptVal,'this.refMap[item.id].iptVal')
          //   //         if(this.refMap[item.id].iptVal  == '') {
          //   //              this.setValidationMessage(false,`${this.refMap[item.id].option.attribute.label}必填`);
          //   //              return false
          //   //         }
          //   //     }
          //   //  })
          // }
      }
      const { attribute } = this.option;
      // 1,当iptVal为空时 提示新密码不能为空，
      // 2，当iptVal1为空时 提示确认密码不能为空，
      // 3，当iptVal和iptVal1不相等时，提示密码不一致，
      // 4,当attribute.psLevel 为 small，检测 iptVal与iptVal1 输入规则是否符合规则，不符合规则 分别提示attribute.label 与 attribute.dblabel输入规则不符
      // 5,当attribute.psLevel 为 medium，检测 iptVal与iptVal1 输入规则是否符合规则，不符合规则 分别提示attribute.label 与 attribute.dblabel 输入规则不符
      // 6,当attribute.psLevel 为 large，检测 iptVal与iptVal1 输入规则是否符合规则，不符合规则 分别提示attribute.label 与 attribute.dblabel 输入规则不符
      //   const small = new RegExp(`^[\\S]{${this.min},${this.max}}$`);
      //   const medium = new RegExp(`^(?=.*[A-Za-z])(?=.*\\d)[\\da-zA-Z]{${this.min},${this.max}}$`);
      //   const large =  new RegExp(`^(?=.*[A-Z])(?=.*[a-z])(?=.*\\d)(?=.*[~!@#$%^&*_.]).{${this.min},${this.max}}$`);
      //   if (!this.iptVal) {
      //     this.setValidationMessage(false, `${attribute.label}必填`);
      //     return false;
      //   }
      //   if (!this.iptVal1) {
      //     this.setValidationMessage(false, `${attribute.dblabel}必填`);
      //     return false;
      //   } 
      //   if (attribute.psLevel == 'small' &&  !small.test(this.iptVal)) {
      //       this.setValidationMessage(false, `请输入6~20位非空格字符密码`);
      //       return false;
      //   }
      //   if (attribute.psLevel == 'medium' &&  !medium.test(this.iptVal)) {
      //       this.setValidationMessage(false, `请输入6~20位包含大小写字母和数字的密码`);
      //       return false;
      //   }
      //   if (attribute.psLevel == 'large' &&  !large.test(this.iptVal)) {
      //       this.setValidationMessage(false, `请输入6~20位包含大小写字母、数字、特殊字符(~!@#$%^&*_.)的密码`);
      //       return false;
      //   }

      // // 所有条件都通过后清除错误消息，并返回true
      // this.setValidationMessage(true);
      // return true;

    },

   setValidationMessage(isValid, errorMessage = "") {
    this.message = isValid ? "default" : "error";
    this.tips = isValid ? "" : errorMessage;
    },
    test() {
      console.log(this.checkValue(),'-----')
    }
  },
};
</script>

<style scoped>
.my_password /deep/ .t-form__label {
   color:var(--textColor);
   font-style: var(--fontStyle);
   font-weight: var(--fontWeight);
   font-family: var(--fontFamily);
   font-size: var(--fontSize);
   line-height: var(--height);
}

.my_password_item /deep/ .t-input .t-input__inner::placeholder {
   color: var(--placholderColor); 
 }

.my_password_item /deep/ .t-input .t-input__inner {
  padding-left: var(--indent);
  color: var(--textColor);
  font-style: var(--fontStyle);
  font-weight: var(--fontWeight);
  font-family: var(--fontFamily);
  font-size: var(--fontSize);
}

.my_password_item /deep/ .t-input {
  background-color: var(--bgColor);
  border-width: var(--borderSize);
  border-color: var(--borderColor);
  border-radius: var(--borderRadius);
  border-style: var(--lineType);
  min-height: var(--height);
}

.my_password_item /deep/.t-input:focus {
     box-shadow: none !important;
     border-color:var(--borderColor);
}

.my_password_item /deep/.t-input:hover {
     box-shadow: none !important;
     border-color:var(--borderColor);
}

.my_password_item /deep/.t-input--focused {
     box-shadow: none !important;
     border-color:var(--borderColor);
}

.my_password_item /deep/.t-is-focused {
     box-shadow: none !important;
     border-color:var(--borderColor);
}
</style>